import React, {Component} from "react"
import {Button, Icon, Image} from "semantic-ui-react"
import Attachments from "../Attachments"
import api from "../../../api"
import PropTypes from "../../../PropTypes"
import _ from "lodash"
import {withTranslation} from 'react-i18next'

class FormAttachments extends Component {

    static propTypes = {
        step: PropTypes.step,
        onChange: PropTypes.func
    }

    constructor({step}) {
        super()
        this.state = {
            loading: false,
            step,
            additionalImages: []
        }
    }

    render() {
        let {step, loading, additionalImages} = this.state
        const {t} = this.props;

        return (
            <div className="ui form ">
                <div className="field pt4">
                    <label>{t("general.attachments")}</label>
                    <Attachments accept=".jpg,.jpeg,.png"
                                 onChange={({files}) => {
                                     this.setState({loading: true})
                                     const stepId = step.Id
                                     api.postAttachment({files, stepId})
                                         .then(() => {
                                             // additionalImages.push({URI: imageDefaultSrc})
                                             api.loadOrder().then(order => {
                                                 try {
                                                     let updatedStep = order.Steps.filter(s => s.Id === step.Id)[0]
                                                     this.setState({
                                                         loading: false,
                                                         step: updatedStep
                                                     })
                                                 } catch (e) {
                                                     console.warn("Error while loading Service Request", e)
                                                 }
                                             })
                                         })
                                 }}>
                        <Button loading={loading} basic><Icon name="upload"/>{t("general.add.images")}</Button>
                    </Attachments>
                </div>
                <div>
                    <Image.Group size="tiny">
                        {_.map([...step.Attachments, ...additionalImages], (attachment, key) => {
                            return <Image key={key} src={attachment.URI} size="tiny" href={attachment.URI}
                                          target="_blank"/>
                        })}
                    </Image.Group>
                </div>
            </div>
        )
    }
}

export default withTranslation()(FormAttachments)


// WEBPACK FOOTER //
// ./src/pages/components/Step/FormAttachments.js